"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getRate = require("./getRate");
Object.keys(_getRate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getRate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getRate[key];
    }
  });
});